import React, { useEffect, useState } from "react"
import { Button, Container, IconButton, LinearProgress, Menu, TextField } from "@mui/material"
import { Chat, Clear, Send, Visibility } from "@mui/icons-material";
import axios from "axios";
import { Fetchconversationsurl } from "../../../utils/chaturls";
import { Postadminmessageurl } from "../../../utils/chaturls";
import { useRef } from "react";



const Clientmessages = ({ messagecounter, clientid, conversationid }) => {

    const [loading, setloading] = useState(false);
    const [error, seterror] = useState(false);
    const [success, setsuccess] = useState('');
    const [message, setmessage] = useState('');
    const [conversations, setconversations] = useState([]);

    const [anchorEl, setAnchorEl] = useState('');
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const wrapChatMessagesRef = useRef(null);

    // Function to scroll to the bottom of the div
    const scrollToBottom = () => {
        if (wrapChatMessagesRef.current) {
            const scrollHeight = wrapChatMessagesRef.current.scrollHeight;
            const height = wrapChatMessagesRef.current.clientHeight;
            const maxScrollTop = scrollHeight - height;
            wrapChatMessagesRef.current.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
        }
    };

    useEffect(() => {
        fetchmymessages()
    }, [success]);



    const fetchmymessages = () => {
        seterror()
        setloading(true)
        axios.post(Fetchconversationsurl, {
            clientid: clientid
        }).then(response => {
            setloading(false)
            if (!response.data.error) {
                setconversations(response.data)
                scrollToBottom()
            } else {
                if (response.data.message) {
                    seterror(response.data.message)
                } else {
                    seterror(response.data.error)
                }
            }
        }).catch(error => {
            setloading(false)
            seterror("Sorry an error occurred,try again later");
            //if(error.response.status === 401 || error.response.status === 400){}
        });

    }

    useEffect(() => {
        fetchsilent()
    }, [messagecounter]);


    //fetch silent
    const fetchsilent = () => {
        axios.post(Fetchconversationsurl, {
            clientid: clientid
        }).then(response => {
            if (!response.data.error) {
                setconversations(response.data)
                scrollToBottom()
            }
        })
    }


    //send messages 
    const sendmessage = () => {
        seterror()
        setloading(true)
        axios.post(Postadminmessageurl, {
            message: message,
            clientid: clientid,
            conversationid: conversationid
        }).then(response => {
            setloading(false)
            if (!response.data.error) {
                setmessage('')
                setsuccess(!success)
            } else {
                if (response.data.message) {
                    seterror(response.data.message)
                } else {
                    seterror(response.data.error)
                }
            }
        }).catch(error => {
            setloading(false)
            seterror("Sorry an error occurred,try again later");
            //if(error.response.status === 401 || error.response.status === 400){}
        });
    }





    //conversations
    const Conversations = () => {
        return (
            <div>
                {conversations[0]?.messages?.map((val, key) => {
                    return (
                        <div key={key} className={val.agentid ? "chatmine" : "chatsender"}>
                            <div className={val.agentid ? "messagetext" : "messagetextsender"}>{val.message}</div>
                        </div>
                    )
                })}
            </div>
        )
    }


    // Function to handle Enter key press
    const handleKeyPress = (e) => {
        e.stopPropagation()
        if (e.key === 'Enter') {
            e.preventDefault();
            sendmessage()
        }
    };


    return (
        <div>
            <Button onClick={handleClick} startIcon={<Visibility />} variant="outlined" >View</Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                PaperProps={{ sx: { width: '400px', height: '550px' } }}
            >
                <Container maxWidth="md" sx={{ width: "100%" }} >
                    {loading && <LinearProgress />}
                    <div style={{ position: "absolute", right: "5px", top: "5px" }}>
                        <IconButton onClick={() => handleClose()}>
                            <Clear />
                        </IconButton>
                    </div>
                    <div className="chatheader">
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div className="companyname">
                                Primesoft Kenya
                            </div>
                            <div className="onlinedot" />
                        </div>
                        <div className="typicallyreplytext">Typically replies in a few minutes</div>
                    </div>
                    <div className="wrapchatmessages" ref={wrapChatMessagesRef}>
                        <Conversations />
                    </div>
                    <div className="wrapchatbottom" >
                        {conversations?.length > 0 &&
                            <div className="wrapstartmessagediv">
                                <TextField
                                    id="outlined-basic"
                                    sx={{ marginBottom: 2, width: "80%" }}
                                    value={message}
                                    onKeyDown={handleKeyPress}
                                    onChange={(e) => setmessage(e.target.value)}
                                    variant="outlined"
                                    size="small" />
                                <Button sx={{ marginTop: -2 }} disabled={!message && true} onClick={() => sendmessage()} endIcon={<Send fontSize="25px" color={message && "primary"} />} />
                            </div>
                        }
                        <div className="poweredbydiv">
                            <Chat sx={{ fontSize: 12 }} />&nbsp;  Powered by Primesoft
                        </div>
                    </div>
                </Container>
            </Menu>
        </div>
    )
}

export default Clientmessages